module.exports = __webpack_public_path__ + "media/images/footer_2023-a67c34dc6629664d8541de3722ae61d5.png";